var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 10.532 17.992"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Chevron",
    d: "M8.37,17.626.256,9.607a.855.855,0,0,1,0-1.221L8.37.366a1.278,1.278,0,0,1,1.791,0,1.242,1.242,0,0,1,0,1.769L3.22,9l6.941,6.859a1.243,1.243,0,0,1,0,1.77,1.278,1.278,0,0,1-1.791,0",
    fill: "#0b535f"
  })));
};
export default __webpack_public_path__ + "static/media/arrow.da796a83.svg";
export { SvgComponent as ReactComponent };